import { AppEnvironment, AppName } from '@showbie/utilities/message';
import { atom, useAtom } from 'jotai';

interface ShowbieAppInfo {
  version?: string;
  name?: AppName;
  environment?: AppEnvironment;
}

const showbieAppInfoAtom = atom<ShowbieAppInfo>({});

export function useShowbieAppInfo() {
  const [appInfo] = useAtom(showbieAppInfoAtom);
  return appInfo;
}

export function useSetShowbieAppInfo() {
  const [, setAppInfo] = useAtom(showbieAppInfoAtom);
  return setAppInfo;
}
